import React, { Component } from "react";
import ErrorBooundary from "components/ErrorBoundary";
import BookAppointment from "./BookAppointment";

class BookAppointmentContainer extends Component {
  render() {
    return (
      <ErrorBooundary>
        <BookAppointment />
      </ErrorBooundary>
    );
  }
}

export default BookAppointmentContainer;



// WEBPACK FOOTER //
// ./containers/BookAppointmentContainer.js